import { TaxInfo } from './types';

export const compareTaxes = (taxA: TaxInfo, taxB: TaxInfo): -1 | 0 | 1 => {
  const taxNameA = Number.parseInt(taxA.name, 10);
  const taxNameB = Number.parseInt(taxB.name, 10);
  if (taxNameA > taxNameB) {
    return 1;
  }

  if (taxNameA < taxNameB) {
    return -1;
  }

  const productTypeA = taxA.productType?.toLowerCase() || '';
  const productTypeB = taxB.productType?.toLowerCase() || '';
  if (productTypeA > productTypeB) {
    return 1;
  }

  if (productTypeA < productTypeB) {
    return -1;
  }

  return 0;
};
